import { useCallback, useEffect, useRef } from 'react'
import { createContext, useContext, useState } from 'react'
import Spinner from '../../containers/Spinner'
import { api, setApiURL } from '../../services/api'

const ConfigContext = createContext()
export const useConfig = () => useContext(ConfigContext)

export const ConfigContextProvider = ({ children }) => {
  const [config, setConfig] = useState()
  const [offset, setOffset] = useState()
  let run = useRef()

  const throttle = useCallback((cb, delay) => {
    return function () {
      if (!run.current) {
        cb()
        run.current = true
        setTimeout(() => (run.current = false), delay)
      }
    }
  }, [])

  const getConfig = async () => {
    fetch('/appsettings.json')
      .then((res) => res.json())
      .then((configData) => {
        const { apiURL } = configData
        if (process.env.NODE_ENV !== 'development') {
          setApiURL(apiURL)
        }
        setConfig(configData)
      })
  }

  const getShipmentInfo = async () => {
    api.utilities
      .getShipmentInfo()
      .then((res) => res.json())
      .then((data) =>
        setConfig((prevConfig) => ({ ...prevConfig, shipmentInfo: data }))
      )
  }

  const getNavbarOffset = (yOffset) => {
    setOffset(yOffset)
  }

  useEffect(() => {
    getConfig()
    getShipmentInfo()
  }, [])

  return (
    <ConfigContext.Provider
      value={{ config, offset, getNavbarOffset, throttle }}
    >
      {config ? children : <Spinner />}
    </ConfigContext.Provider>
  )
}

export default ConfigContext
